import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarService } from '../../../services/snackBar.service';
import { SpinnerService } from '../../../services/spinner.service';
import { takeUntil } from 'rxjs/operators';
import { Constants } from '../../../utils/constants';
import { StringUtils } from '../../../utils/stringUtils';
import { MyErrorStateMatcher } from '../../../utils/errorStateMatcher';

@Component({
    selector: 'app-restore-password-client',
    templateUrl: './restore-password-client.component.html',
    styleUrls: ['./restore-password-client.component.scss'],
    standalone: false,
})
export class RestorePasswordClientComponent implements OnInit {

  matcher = new MyErrorStateMatcher();
  changePasswordForm: UntypedFormGroup;

  username: string;
  token: string;

  newPassword: string;
  confirmPassword: string;

  error: string;
  message: string;

  private destroy$ = new Subject<void>();

  constructor(
    fb: UntypedFormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private loginService: LoginService,
    private translate: TranslateService,
    public snackBarService: SnackBarService,
    private spinnerService: SpinnerService) {

    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
      this.username = params[Constants.FIELD_USERNAME];
      this.token = params[Constants.FIELD_TOKEN];

      if (StringUtils.isEmpty(this.username) || StringUtils.isEmpty(this.token)) {
        this.backLogin();
      }
    });

    this.changePasswordForm = fb.group({
      username: [{ value: this.username, disabled: true }],
      newPassword: [this.newPassword, [Validators.required, Validators.pattern(Constants.PASSWORD_PATTERN)]],
      confirmPassword: [this.confirmPassword, [Validators.required, Validators.pattern(Constants.PASSWORD_PATTERN)]]
    }, { validator: this.checkPasswords });

  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  checkPasswords(group: UntypedFormGroup): any { // here we have the 'passwords' group
    const pass = group.controls.newPassword.value;
    const confirmPass = group.controls.confirmPassword.value;

    return pass === confirmPass ? null : { notMatch: true };
  }

  changePassword(): void {
    this.spinnerService.show();

    this.error = null;
    this.message = null;

    if (!this.changePasswordForm.valid) {
      if (this.changePasswordForm.errors[Constants.FIELD_NO_MATCH]) {
        this.error = this.translate.instant('changePassword.form.error.notMatch') as string;
      }

      return;
    }

    this.loginService.changePassword(this.username, this.token, this.newPassword).pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.snackBarService.sendSuccess(this.translate.instant('changePassword.form.ok') as string);
      this.spinnerService.hide();

      this.backLogin();

    }, err => {
      this.snackBarService.sendError(err.error as string);
      this.spinnerService.hide();
    });

  }

  backLogin(): void {
    void this.router.navigate(['/login-client'], { queryParamsHandling: 'merge' });
  }

}
